"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { type UseQueryOptions, useMutation, useQuery } from "@tanstack/react-query";
import { useUserData } from "@/hooks/useUserData";
import { getQueryClient } from "@/queries/config/query-client";
import { workspaceMutationKeys } from "@/queries/query-keys/workspace";
import { getUserQueryOptions } from "@/queries/user/fetchers";
import { getWorkspacesQueryOptions } from "@/queries/workspace/fetchers";
import { createWorkspace, type WorkspacesResponse } from "@/queries/workspace/inserts";
const queryClient = getQueryClient();
/**
 * Custom hook for managing workspaces
 * Provides functions to fetch, create, and manage workspaces
 */
export function useWorkspaces() {
  const $ = _c(15);
  const {
    userData
  } = useUserData();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getWorkspacesQueryOptions();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const queryOptions = t0;
  const t1 = userData?.id;
  let t2;
  if ($[1] !== t1) {
    t2 = getUserQueryOptions(t1);
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const userQueryOptions = t2;
  const t3 = !!userData?.id;
  let t4;
  if ($[3] !== t3) {
    t4 = {
      ...(queryOptions as UseQueryOptions<WorkspacesResponse>),
      enabled: t3
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const {
    data,
    isLoading: loadingWorkspaces,
    refetch: fetchWorkspaces
  } = useQuery(t4);
  let t5;
  if ($[5] !== userQueryOptions) {
    t5 = {
      mutationFn: createWorkspace,
      mutationKey: workspaceMutationKeys.create,
      onSuccess: async () => {
        await Promise.all([queryClient.invalidateQueries({
          queryKey: queryOptions.queryKey,
          refetchType: "all"
        }), queryClient.invalidateQueries({
          queryKey: userQueryOptions.queryKey,
          refetchType: "all"
        })]);
      }
    };
    $[5] = userQueryOptions;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const {
    mutateAsync: createNewWorkspace,
    isPending: creatingWorkspace
  } = useMutation(t5);
  let t6;
  if ($[7] !== data?.workspaces) {
    t6 = data?.workspaces || [];
    $[7] = data?.workspaces;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== createNewWorkspace || $[10] !== creatingWorkspace || $[11] !== fetchWorkspaces || $[12] !== loadingWorkspaces || $[13] !== t6) {
    t7 = {
      createNewWorkspace,
      creatingWorkspace,
      loadingWorkspaces,
      loadWorkspaces: fetchWorkspaces,
      workspaces: t6
    };
    $[9] = createNewWorkspace;
    $[10] = creatingWorkspace;
    $[11] = fetchWorkspaces;
    $[12] = loadingWorkspaces;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}